<template>
  <div class="container center-align">
    <img
      class="image"
      src="@/assets/img/1x/Business-Notifications-Dark.png"
      alt="Error"
    />
    <div class="mensaje-wrapper">
      <p class="title" v-safe-html="config.pasos.errorBBVAVos.titulo"></p>
      <p
        class="subtitule"
        v-safe-html="config.pasos.errorBBVAVos.subtitulo"
      ></p>
    </div>
  </div>
</template>

<script>
export default {
  name: "ErrorBBVAVos"
};
</script>

<style scoped>
.center-align {
  text-align: center;
}
div.sales-button {
  width: 212px;
  height: 56px;
}

div.mensaje-wrapper {
  color: #121212;
  font-size: 18px;
  margin: auto;
  max-width: 500px;
  margin-top: 16px;
  margin-bottom: 42px;
}

div.button-container {
  text-align: center;
}

@media screen and (max-width: 600px) {
  div.mensaje-wrapper {
    max-width: 290px;
  }
}

.title {
  font-weight: normal;
  font-size: 20px;
  line-height: 28px;
  color: #121212;
  font-family: "BentonSansBBVA-Medium", Arial, sans-serif;
}

.subtitle {
  margin-top: 5%;
  font-size: 15px;
  line-height: 24px;
  font-weight: normal;
  font-family: "BentonSansBBVA-Book", Helvetica, Arial, sans-serif;
}

.image {
  margin-top: 5%;
  margin-bottom: 5%;
  width: 25%;
}
</style>
